<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div v-if="isLoading" class="page-loading-overlay">
        <div class="spinner-border text-primary dashboard-spinner" role="status">
          <span class="visually-hidden">Chargement...</span>
        </div>
      </div>
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>List des Bons de Livraison</h4>
            <h6>Gérer vos Bons de Livraison</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf" @click.prevent="exportPDF"
              ><img src="@/assets/img/icons/pdf.svg" alt="img"
            /></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel" @click.prevent="exportCSV"
              ><img src="@/assets/img/icons/excel.svg" alt="img"
            /></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Print" @click.prevent="printTable"
              ><i data-feather="printer" class="feather-printer"></i
            ></a>
          </li>
          <li>
            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh" @click.prevent="refreshList"
              ><i data-feather="rotate-ccw" class="feather-rotate-ccw"></i
            ></a>
          </li>
          <li>
            <a
              ref="collapseHeader"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Collapse"
              @click="toggleCollapse"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn">
          <a
            href="javascript:void(0);"
            class="btn btn-added"
            data-bs-toggle="modal"
            data-bs-target="#add-units"
            ><vue-feather type="plus-circle" class="me-2"></vue-feather>Ajouter
            un nouveau Bon</a
          >
        </div>
      </div>
      <!-- /product list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input">
                <input
                  type="text"
                  placeholder="Recherche"
                  class="dark-input"
                  v-model="searchQuery"
                  @input="applyFilters"
                  @keyup.enter="applyFilters"
                />
                <a href="" class="btn btn-searchset" @click.prevent="applyFilters"
                  ><vue-feather type="search" class="feather-search"></vue-feather
                ></a>
              </div>
            </div>
          </div>
          <!-- /Search -->
          <div class="table-responsive">
            <a-table
              class="table datanew"
              :columns="columns"
              :data-source="pagedFilteredData"
               :row-selection="{}"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'CategoryName'">
                  <div class="userimgname cust-imgname">
                    <a href="javascript:void(0);" class="product-img">
                      <img
                        :src="require(`@/assets/img/${record.Image}`)"
                        alt="product"
                      />
                    </a>
                    <a href="javascript:void(0);">{{ record.CategoryName }}</a>
                  </div>
                </template>
                <template v-else-if="column.dataIndex === 'statut'">
                  <div>
                    <span :class="blStatusBadge(record.statut)">{{ blStatusLabel(record.statut) }}</span>
                  </div>
                </template>
                <template v-else-if="column.key === 'action'">
                  <div class="action-table-data">
                    <div class="edit-delete-action">
                      <!-- <a class="me-2 p-2" href="javascript:void(0);">
                        <i data-feather="eye" class="feather-eye"></i>
                      </a> -->
                      <a
                        class="me-2 p-2"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#edit-units"
                        @click="openEditModal(record)"
                      >
                        <i data-feather="edit" class="feather-edit"></i>
                      </a>
                      <a
                        class="me-2 p-2"
                        href="javascript:void(0);"
                        @click="handlePdf(record)"
                        ><vue-feather
                          type="download"
                          class="info-img"
                        ></vue-feather
                      ></a>
                      <a
                        class="confirm-text p-2"
                        @click="showConfirmation(record.id)"
                        href="javascript:void(0);"
                      >
                        <i data-feather="trash-2" class="feather-trash-2"></i>
                      </a>
                    </div>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
         <!-- pagination controls -->
         <nav v-if="totalItems > 0" class="mt-3">
           <div class="d-flex align-items-center justify-content-between">
             <div class="d-flex align-items-center gap-2">
               <label class="small text-muted mb-0">Afficher</label>
               <select class="form-select form-select-sm" v-model.number="pageSize" @change="changePageSize" style="width: auto;">
                 <option :value="10">10</option>
                 <option :value="25">25</option>
                 <option :value="50">50</option>
               </select>
               <span class="small text-muted"> / {{ totalItems }} éléments</span>
             </div>

             <ul class="pagination mb-0">
               <li class="page-item" :class="{ disabled: page <= 1 }">
                 <button class="page-link" @click="goToPage(page - 1)" :disabled="page <= 1">Précédent</button>
               </li>
               <li v-for="p in visiblePages" :key="p" class="page-item" :class="{ active: p === page }">
                 <button class="page-link" @click="goToPage(p)">{{ p }}</button>
               </li>
               <li class="page-item" :class="{ disabled: page >= totalPages }">
                 <button class="page-link" @click="goToPage(page + 1)" :disabled="page >= totalPages">Suivant</button>
               </li>
             </ul>
           </div>
         </nav>
        </div>
      </div>
      <!-- /product list -->
    </div>
  </div>
  <bon-livraison-modal
    @bon-added="onBonAdded"
    :data="selectedBon"
    @bon-updated="onBonUpdated"
  ></bon-livraison-modal>
</template>
<script>
import { getBonsData, deleteBonLivraison } from "@/services/deliveryService";
import { formatDate } from "@/utils/date";
import { toast } from "vue3-toastify";
import { getClientsData } from "@/services/clientsService";
import { generateCommandPdf } from "@/services/pdfService";
import { getCompanyData, getCompanyLogoDataUrl } from "@/services/companyService";
import { getLignesCommandeDataByCommandeId } from "@/services/devisService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
const columns = [
  {
    title: "N° Bon",
    dataIndex: "numero_bon",
    sorter: {
      compare: (a, b) => {
        a = a.CategoryName.toLowerCase();
        b = b.CategoryName.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "N° Facture",
    dataIndex: "numero_facture",
    sorter: {
      compare: (a, b) => String(a?.numero_facture || "").localeCompare(String(b?.numero_facture || ""), "fr", { sensitivity: "base" }),
    },
  },
  {
    title: "Date de création",
    dataIndex: "date_creation",
    key: "date_creation",
    customRender: ({ text }) => {
      return formatDate(text);
    },
    sorter: (a, b) => {
      const dateA = new Date(a.date_creation.replace(" ", "T"));
      const dateB = new Date(b.date_creation.replace(" ", "T"));
      return dateA - dateB;
    },
  },
  {
    title: "Date de livraison",
    dataIndex: "date_livraison",
    key: "date_livraison",
    customRender: ({ text }) => {
      return formatDate(text);
    },
    sorter: (a, b) => {
      const dateA = new Date(a.date_livraison.replace(" ", "T"));
      const dateB = new Date(b.date_livraison.replace(" ", "T"));
      return dateA - dateB;
    },
  },
  {
    title: "Statut",
    dataIndex: "statut",
    key: "statut",
    sorter: {
      compare: (a, b) => {
        a = a.Email.toLowerCase();
        b = b.Email.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Transporteur",
    dataIndex: "transporteur",
    sorter: {
      compare: (a, b) => {
        a = a.Phone.toLowerCase();
        b = b.Phone.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Adresse de livraison",
    dataIndex: "adresse_livraison",
    sorter: {
      compare: (a, b) => {
        a = a.Code.toLowerCase();
        b = b.Code.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Notes",
    dataIndex: "notes_livraison",
    sorter: {
      compare: (a, b) => {
        a = a.Country.toLowerCase();
        b = b.Country.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
const data = [];
const clientData = [];
const clientIds = [];
const clients = [];
import Swal from "sweetalert2";
export default {
  data() {
    return {
      searchQuery: "",
      filteredData: [],
      data,
      columns,
      selectedBon: {},
      clientData,
      clientIds,
      company: {},
      clients,
      isLoading: false,
      // pagination
      page: 1,
      pageSize: 10,
    };
  },
  computed: {
    totalItems() {
      return (this.filteredData && this.filteredData.length) || 0;
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.totalItems / this.pageSize));
    },
    visiblePages() {
      const total = this.totalPages;
      const current = Number(this.page || 1);
      const maxVisible = 7;
      if (total <= maxVisible) return Array.from({ length: total }, (_, i) => i + 1);
      const half = Math.floor(maxVisible / 2);
      let start = Math.max(1, current - half);
      let end = start + maxVisible - 1;
      if (end > total) {
        end = total;
        start = end - maxVisible + 1;
      }
      const pages = [];
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    },
    pagedFilteredData() {
      const list = this.filteredData || [];
      const start = (this.page - 1) * this.pageSize;
      return list.slice(start, start + this.pageSize);
    },
  },
  methods: {
    // Status rendering helpers for BL list
    blStatusBadge(status) {
      const s = String(status || '').toUpperCase();
      switch (s) {
        case 'LIVRÉ':
          return 'badges bg-lightgreen';
        case 'EN_ATTENTE':
        case 'EN_COURS':
          return 'badges bg-lightyellow';
        case 'ANNULÉ':
        case 'RETOURNÉ':
          return 'badges bg-lightred';
        default:
          return 'badges status-badge';
      }
    },
    blStatusLabel(status) {
      const s = String(status || '').toUpperCase();
      switch (s) {
        case 'LIVRÉ':
          return 'Livré';
        case 'EN_ATTENTE':
          return 'En attente';
        case 'EN_COURS':
          return 'En cours';
        case 'ANNULÉ':
          return 'Annulé';
        case 'RETOURNÉ':
          return 'Retourné';
        default:
          return status || '';
      }
    },
    // Print current BL table (filtered if search is active) with logo + footer
    async printTable() {
      const rows = this.filteredData && this.filteredData.length ? this.filteredData : this.data;
      const win = window.open("", "_blank");
      if (!win) return;
      let logo = "";
      try { logo = await getCompanyLogoDataUrl('logo'); } catch (_) { /* ignore logo fetch */ }
      const c = this.company || {};
      const esc = (s) => String(s ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      const line1 = esc(c.name || '');
      const line2 = esc([c.address, c.code_postal].filter(Boolean).join(' | '));
      const line3 = esc([c.email, c.url].filter(Boolean).join(' | '));
      const taxBits = [];
      if (c.rc) taxBits.push(`RC: ${esc(c.rc)}`);
      if (c.if) taxBits.push(`IF: ${esc(c.if)}`);
      if (c.ice) taxBits.push(`ICE: ${esc(c.ice)}`);
      if (c.tp) taxBits.push(`TP: ${esc(c.tp)}`);
      if (c.cnss) taxBits.push(`CNSS: ${esc(c.cnss)}`);
      const line4 = taxBits.join(' | ');

      const html = `
        <html>
          <head>
            <title>Liste des Bons de Livraison</title>
            <style>
              @page { size: A4 portrait; margin: 16mm; }
              body{font-family: Arial, Helvetica, sans-serif; margin:0;}
              .header{position:fixed; top:0; left:0; right:0; text-align:center; padding-top:6mm;}
              .header img{ max-height:40px; }
              .wrap{ margin: 60px 0 70px 0; }
              h3{ margin: 0 0 10px 0; }
              table{width:100%;border-collapse:collapse}
              th,td{border:1px solid #ccc;padding:6px;text-align:left;font-size:12px}
              thead th{background:#1E68A3;color:#fff}
              .footer{position:fixed; left:16mm; right:16mm; bottom:10mm; font-size:11px;}
              .page-num{position:fixed; right:16mm; bottom:6mm; color:#888; font-size:11px;}
            </style>
          </head>
          <body>
            <div class="header">${logo ? `<img src="${logo}" alt="logo"/>` : ''}</div>
            <div class="wrap">
              <h3>Liste des Bons de Livraison</h3>
              <table>
                <thead>
                  <tr>
                    <th>N° Bon</th>
                    <th>N° Facture</th>
                    <th>Date Livraison</th>
                    <th>Statut</th>
                    <th>Transporteur</th>
                  </tr>
                </thead>
                <tbody>
                  ${rows.map(r => `
                    <tr>
                      <td>${esc(r.numero_bon || '')}</td>
                      <td>${esc(r.numero_facture || '')}</td>
                      <td>${esc(r.date_livraison || '')}</td>
                      <td>${esc(r.statut || '')}</td>
                      <td>${esc(r.transporteur || '')}</td>
                    </tr>`).join("")}
                </tbody>
              </table>
            </div>
            <div class="footer">
              ${line1 ? `<div>${line1}</div>` : ''}
              ${line2 ? `<div>${line2}</div>` : ''}
              ${line3 ? `<div>${line3}</div>` : ''}
              ${line4 ? `<div>${line4}</div>` : ''}
            </div>
            <div class="page-num"></div>
          </body>
        </html>`;
      win.document.open();
      win.document.write(html);
      win.document.close();
      setTimeout(() => { try { win.focus(); win.print(); } catch(e){ /* ignore */ } }, 100);
    },

    async exportPDF() {
      const rows = this.filteredData && this.filteredData.length ? this.filteredData : this.data;
      if (!rows || !rows.length) return;
      const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const headerHeight = 26;
      const margin = 12;

      let logo = null;
      try { logo = await getCompanyLogoDataUrl('logo'); } catch (e) { /* ignore */ }
      const drawHeader = () => {
        if (!logo) return;
        const w = 30, h = 12, x = (pageWidth - w) / 2, y = 8;
        try {
          const fmt = logo.startsWith('data:image/png') ? 'PNG' : 'JPEG';
          doc.addImage(logo, fmt, x, y, w, h);
        } catch (_) { /* ignore */ }
      };
      const drawFooter = () => {
        const leftX = margin;
        let y = pageHeight - 22;
        const maxWidth = pageWidth - 2 * margin;
        const lineHeight = 4.2;
        doc.setFontSize(9);
        const write = (text) => {
          if (!text) return;
          const wrapped = doc.splitTextToSize(String(text), maxWidth);
          wrapped.forEach((ln) => { doc.text(ln, leftX, y); y += lineHeight; });
        };
        const c2 = this.company || {};
        const line1 = c2.name ? String(c2.name) : '';
        const line2 = [c2.address, c2.code_postal].filter(Boolean).join(' | ');
        const line3 = [c2.email, c2.url].filter(Boolean).join(' | ');
        const taxBits = [];
        if (c2.rc) taxBits.push(`RC: ${c2.rc}`);
        if (c2.if) taxBits.push(`IF: ${c2.if}`);
        if (c2.ice) taxBits.push(`ICE: ${c2.ice}`);
        if (c2.tp) taxBits.push(`TP: ${c2.tp}`);
        if (c2.cnss) taxBits.push(`CNSS: ${c2.cnss}`);
        const line4 = taxBits.join(' | ');
        write(line1); write(line2); write(line3); write(line4);
      };

      const body = rows.map((r) => [
        r.numero_bon || '-',
        r.numero_facture || '-',
        r.date_livraison || '-',
        r.statut || '-',
        r.transporteur || '-',
      ]);

      const startY = headerHeight + 12;
      autoTable(doc, {
        startY,
        head: [[ 'N° Bon', 'N° Facture', 'Date Livraison', 'Statut', 'Transporteur' ]],
        body,
        headStyles: { fillColor: [30, 104, 163], textColor: 255, fontStyle: 'bold', fontSize: 9, halign: 'center' },
        styles: { fontSize: 8, cellPadding: 3, overflow: 'linebreak', cellWidth: 'wrap' },
        columnStyles: {
          0: { cellWidth: 30 },
          1: { cellWidth: 35 },
          2: { cellWidth: 32, halign: 'center' },
          3: { cellWidth: 28, halign: 'center' },
          4: { cellWidth: 50 },
        },
        alternateRowStyles: { fillColor: [245, 245, 245] },
        didDrawPage: () => {
          drawHeader();
          drawFooter();
          const pageCount = doc.internal.getNumberOfPages();
          const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
          doc.setFontSize(9); doc.setTextColor(120);
          doc.text(`Page ${currentPage} sur ${pageCount}`, pageWidth - margin, pageHeight - 6, { align: 'right' });
          doc.setTextColor(0);
        },
        margin: { left: margin, right: margin, top: startY, bottom: 26 },
      });

      const timestamp = new Date().toISOString().slice(0, 10);
      const filename = `bons_livraison_${timestamp}.pdf`;
      doc.save(filename);
    },

    exportCSV() {
      const rows = this.filteredData && this.filteredData.length ? this.filteredData : this.data;
      if (!rows || !rows.length) return;
      const headers = ['N° Bon','N° Facture','Date Livraison','Statut','Transporteur'];
      const csv = [
        headers.join(','),
        ...rows.map(r => [
          r.numero_bon || '',
          r.numero_facture || '',
          r.date_livraison || '',
          r.statut || '',
          r.transporteur || ''
        ].map(v => `"${String(v).replace(/"/g,'""')}"`).join(','))
      ].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `bons_livraison_${new Date().toISOString().slice(0,10)}.csv`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
    },
    // Search helpers
    normalize(str) {
      return String(str ?? '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    },
    applyFilters() {
      const q = this.normalize(this.searchQuery || '').trim();
      if (!q) {
        this.filteredData = [...this.data];
        return;
      }
      this.filteredData = this.data.filter((r) => {
        const fields = [
          r.numero_bon,
          r.numero_facture,
          r.statut,
          r.transporteur,
          r.adresse_livraison,
          r.notes_livraison,
          r.nom_recepteur,
          r.telephone_recepteur,
          r.date_creation,
          r.date_livraison,
        ];
        return fields
          .filter((v) => v !== undefined && v !== null)
          .map((v) => this.normalize(v))
          .some((v) => v.includes(q));
      });
    },
    async refreshList() {
      try {
        await this.getBonsData();
        this.applyFilters();
      } catch (e) {
        console.error(e);
      }
    },
    showConfirmation(id) {
      Swal.fire({
        title: "Es-tu sûr de vouloir supprimer ce Bon de livraison ?",
        text: "Cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprime-le !",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await deleteBonLivraison(id);

            this.data = this.data.filter((item) => item.id !== id);
            Swal.fire({
              icon: "success",
              title: "Supprimer!",
              text: "Votre bon de livraison a été supprimé.",
              confirmButtonClass: "btn btn-success",
            });
          } catch (error) {
            console.error(error);
            toast.error(error.response.data.message);
            toast.error(error.response.data.error);
          }
        }
      });
    },
    formatDate(dateString) {
      let normalized = dateString.replace(" ", "T");

      let d = new Date(normalized);
      if (isNaN(d)) return dateString;
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(d);
    },

    async getBonsData() {
      this.isLoading = true;
      this.data = [];

      try {
        const data = await getBonsData();
        data.map((m) => {
          this.data.push({
            id: m.id,
            numero_bon: m.numero_bon,
            numero_facture: m.facture?.numero_facture || "",
            date_creation: m.date_creation,
            date_livraison: m.date_livraison,
            statut: m.statut,
            transporteur: m.transporteur,
            adresse_livraison: m.adresse_livraison,
            notes_livraison: m.notes_livraison,
            nom_recepteur: m.nom_recepteur,
            telephone_recepteur: m.telephone_recepteur,
            signature_client: m.signature_client,
            facture_id: m.facture_id,
            livreur_id: m.livreur_id,
            numero_suivi: m.numero_suivi,
            societe_id: m.societe_id,
            facture: m.facture,
            CreatedOn: this.formatDate(m.created_at),
          });
        });
        this.applyFilters();
      } catch (error) {
        console.error(error);
        toast.error(error.response.data.message);
      } finally {
        this.isLoading = false;
      }
    },
    toggleCollapse() {
      const collapseHeader = this.$refs.collapseHeader;

      if (collapseHeader) {
        collapseHeader.classList.toggle("active");
        document.body.classList.toggle("header-collapse");
      }
    },
    async onBonAdded() {
      await this.refreshList();
      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Bon créé avec succès.",
        confirmButtonClass: "btn btn-success",
      });
    },
    onBonUpdated(bon) {
      const today = new Date();
      this.data.map((m) => {
        if (m.id == bon.id) {
          m.numero_bon = bon.numero_bon;
          m.date_creation = this.formatDate(bon.created_at);
          m.date_livraison = this.formatDate(bon.date_livraison);
          m.statut = bon.statut;
          m.transporteur = bon.transporteur;
          m.adresse_livraison = bon.adresse_livraison;
          m.notes_livraison = bon.notes_livraison;
          m.nom_recepteur = bon.nom_recepteur;
          m.telephone_recepteur = bon.telephone_recepteur;
          m.signature_client = bon.signature_client;
          m.facture_id = bon.facture_id;
          m.livreur_id = bon.livreur_id;
          m.numero_suivi = bon.numero_suivi;
          m.societe_id = bon.societe_id;
          m.CreatedOn = today.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          });
        }
      });

      this.applyFilters();

      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Bon de livraison modifié avec succès.",
        confirmButtonClass: "btn btn-success",
      });
    },
    openEditModal(item) {
      this.selectedBon = item;
    },
    async getCompanyData() {
      try {
        const result = await getCompanyData();
        const data = result.data;
        this.company = {
          id: data.id,
          name: data.societe_nom,
          address: data.adress,
          email: data.email,
          tel: data.telephone_entreprise,
          ice: data.ice,
          if: data.identifiant_fiscal,
          rc: data.rc,
          code_postal: data.code_postal,
          telephone_personnel: data.telephone_personnel,
          cin: data.cin,
          tp: data.tp,
          cnss: data.cnss,
          lieu_naissance: data.lieu_naissance,
          nom_complet_arabe: data.nom_complet_arabe,
          nom_complet_francais: data.nom_complet_francais,
          nom_banque: data.nom_banque,
          rib: data.rib,
          code_banque_swift: data.code_banque_swift,
          adresse_siege_social_francais: data.adresse_siege_social_francais,
          webesite: data.webesite,
        url: data.url,
        capital: data.capital,
        logo: data.logo,
        logo_small: data.logo_small,
        created_at: data.created_at,
      };
      } catch (error) {
        console.error(error);
        toast.error(error.response.data.message);
      }
    },

    async handlePdf(devis) {
      const clientData = this.findClient(devis.livreur_id);
      // const logoBase64 = await this.getBase64ImageFromUrl(
      //   `${process.env.VUE_APP_URL}storage/${this.company.logo_small}`
      // );

      const products = [];
      let data = [];
      try {
        data = await getLignesCommandeDataByCommandeId(
          devis.facture.commande_id
        );
        data.forEach((item) => {
          products.push({
            nameProduct: item.item_data ? item.item_data.nom : item.nom_libre,
            quantity: item.quantite,
            item_type: item.item_type,
            unit_price: 0,
            tax: 0,
            PTHT: 0,
          });
        });
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "Impossible de récupérer les lignes de la commande.";
        toast.error(message);
        return;
      }
      const mockCommand = {
        type: "bon de livraison",
        nameClient: clientData.nom + " " + clientData.prenom,
        emailClient: clientData.email,
        adressClient: clientData.adresse,
        PhoneClient: clientData.telephone,
        date_created: devis.date_creation,
        Nbdevis: devis.numero_bon,
        facture_ref: devis.facture?.numero_facture || '',
        client_id: devis.livreur_id,
        terms_payment: devis.mode_paiement,
        line: products,
        // fallback source if line is empty
        commande_lines: data,
        notes: devis.notes,
      };

      let logoSmall = "";
      try {
        logoSmall = await getCompanyLogoDataUrl('logo');
      } catch (_) { /* ignore */ }
      const mockCompanyInfo = {
        logoSmall,
        name: this.company.name,
        address: this.company.address,
        postalCode: this.company.code_postal,
        email: this.company.email,
        website: this.company.url,
        companyLegalName: this.company.name,
        capital: this.company.capital,
        bankInfo: {
          name: this.company.nom_banque,
          rib: this.company.rib,
        },
        socialInfo: {
          address: this.company.adresse_siege_social_francais,
          phone: this.company.telephone_personnel,
          email: this.company.email,
          website: this.company.url,
        },
        taxId: {
          rc: this.company.rc,
          if: this.company.if,
          tp: this.company.tp,
          cnss: this.company.cnss,
          ice: this.company.ice,
        },
      };
      const mockfontData = {
        Roboto: {
          normal:
            "https://www.google.com/search?q=http://example.com/fonts/Roboto-Regular.ttf",
          bold: "https://www.google.com/search?q=http://example.com/fonts/Roboto-Bold.ttf",
          italics:
            "https://www.google.com/search?q=http://example.com/fonts/Roboto-Italic.ttf",
          bolditalics:
            "https://www.google.com/search?q=http://example.com/fonts/Roboto-BoldItalic.ttf",
        },
      };
      try {
        generateCommandPdf(mockCommand, mockCompanyInfo, mockfontData);
      } catch (error) {
        console.error("PDF generation failed:", error);
      }
    },
    async getClientsData() {
      this.clientData = [];
      this.clientIds = [];
      try {
        const data = await getClientsData();
        data.map((m) => {
          this.clientData.push(m.nom + " " + m.prenom);
          this.clients.push(m);
          this.clientIds.push(m.id);
        });
      } catch (error) {
        console.error(error);
        toast.error(error.response.data.message);
        toast.error(error.response.data.error);
      }
    },
    getClientID(option) {
      let index = this.clientData.indexOf(option);
      if (index != -1) {
        return this.clientIds[index];
      }
      return index;
    },
    getClientName(id) {
      let index = this.clientIds.indexOf(id);
      if (index != -1) {
        return this.clientData[index];
      }
      return index;
    },
    findClient(id) {
      let index = this.clientIds.indexOf(id);
      if (index != -1) {
        return this.clients[index];
      }
      return index;
    },
    goToPage(p) {
      const target = Number(p);
      if (!Number.isFinite(target)) return;
      if (target < 1 || target > this.totalPages) return;
      this.page = target;
    },
    changePageSize() {
      this.page = 1;
    },
  },
  watch: {
    filteredData() {
      if (this.page > this.totalPages) this.page = 1;
    },
  },
  async mounted() {
    await this.getBonsData();
    await this.getClientsData();
    await this.getCompanyData();
    this.applyFilters();
  },
};
</script>

<style scoped>
.page-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
}

.page-wrapper {
  position: relative;
}

.dashboard-spinner {
  width: 48px;
  height: 48px;
}
</style>
